import React from "react";
import { Form, Tooltip } from "react-bootstrap";
import OverlayTrigger from "../OverlayTrigger";
import { FaInfoCircle } from "react-icons/fa";
import {
  LAST_CONTACT_FILTER_INFO,
  LAST_CONTACT_FILTER_LABEL,
  LAST_CONTACT_FILTER_OPTIONS,
} from "../../utils/constants/lastContactFilter";

export const LastContactFilter = ({
  value,
  onChange,
  label = LAST_CONTACT_FILTER_LABEL,
  info = LAST_CONTACT_FILTER_INFO,
}) => {
  return (
    <Form.Group style={{ width: "100%" }}>
      {label ? (
        <Form.Label className="text-start fw-bolder d-flex align-items-center gap-1">
          {label}
          {info ? (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip className="tooltip">{info}</Tooltip>}
            >
              <span className="info-span" style={{ cursor: "pointer" }}>
                <FaInfoCircle />
              </span>
            </OverlayTrigger>
          ) : null}
        </Form.Label>
      ) : null}
      <Form.Select
        style={{ height: "40px", width: "100%" }}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {LAST_CONTACT_FILTER_OPTIONS.map((option) => (
          <option key={option.value || "none"} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};
